import React, { useContext, useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import ProductItem from './ProductItem'
import Loading from '../../components/Loading'
import { store } from '../../components/HOC/State'
import { translate } from '../translate'
import { axiosInstance } from '../../const/axiosInstance'
import styles from './product.module.css'

export default function Products() {
    const [arr, setArr] = useState([])
    const [filter, setFilter] = useState("")
    const [loading, setLoading] = useState(false)
    const [updateed, setUpdated] = useState(false)
    const {offset, setOffset, setOffsetUpdated, selectedLang} = useContext(store)
    const limit = 20

    let lang = translate[selectedLang]

    const {search} = useLocation()
    const navigate = useNavigate()
    
    useEffect(() => {
      const filter = search.split("=")[1]
      if(search){
        if(filter){
          if(filter === "all" || filter === "crypto" || filter === "simulator"){
             setFilter(filter)
          }else{
              navigate("/products?category=all")
          }
        }
      }else{
        setFilter("all")
      }
    }, [search])

    useEffect(() => {
      setOffset(0)
      setUpdated(true)
    }, [filter])


    useEffect(() => {
      setOffset(0)
      setUpdated(true)
    }, [])

    useEffect(() =>{
      (async() => {
        if(offset > 0){
        if(updateed){
          setLoading(true)
          const res = await axiosInstance.get(`/use/products?category=${filter}&offset=${offset}&limit=${limit}`)
          if(res.data.status){
            setArr([...arr,...res.data.data])
            if(res.data.data.length == 20){
              setOffsetUpdated(false)
            }
          }else{
            setArr([...arr])
          }
          setLoading(false)
        }
      }
      })()
    }, [offset, updateed])

    useEffect(() =>{
      (async() => {
        if(filter){
          setArr([])
            setLoading(true)
            const res = await axiosInstance.get(`/use/products?category=${filter}&offset=0&limit=${limit}`)
            if(res.data.status){
              setArr([...res.data.data])
              if(res.data.data.length == 20){
                setOffsetUpdated(false)
            }}else{
              setArr([])
            }
            setLoading(false)
        }
      })()
    }, [filter])

  return (
    <div>
      <div className={styles['headers-main']}>
        {filter && <img src={filter == "simulator" ? "/gun.jpg" : filter == "crypto" ? "/numberslist.jpg" : "/microschema1.jpg"} />}
        <div className={`${styles['products-category']} ${styles['on-header']}`}>
            <p>{filter === "all" ? lang.tr_product : filter == "crypto" ? lang.tr_crypto1 : lang.tr_shooting1}</p>
            {filter !== "all" && <p>{filter == "crypto" ? lang.tr_crypto2 : lang.tr_shooting2}</p>}
        </div>
      </div>
      <div className={styles['products-main']}> 
          <div className={styles['products-size']}>    
              <div className={styles['filters']}>
              </div>
              <div className={styles['products-list']}>
                {arr.length ? (
                  arr.map(el => (
                      <ProductItem el={el} key={el._id}/>
                  ))
                ):(
                  !loading ? <p className='empty-message'>{lang.tr_noPublished}</p> : null 
                )}
                  {loading ? <Loading width={200}/> : ""}
              </div>
          </div>  
      </div>
    </div>
  )
}
